<template>
  <div class="w-full mx-auto sm:max-w-5xl 2xl:max-w-6xl 3xl:max-w-8xl 4xl:max-w-9xl">
    <IntegrationsHeader />
    <LoginPrompt v-if="!isLoggedIn" />
    <IntegrationsGrid v-if="isLoggedIn" />
    <MeetingsSection v-if="isLoggedIn && hasMeetingsFlag" />
    <AppsSection />
    <ComingSoonSection />
    <WebhooksSettings v-if="isOrgUserAdmin && !isOrgUserViewOnly" />
  </div>
</template>

<script lang="ts" setup>
import IntegrationsHeader from './components/ui/IntegrationsHeader.vue';
import LoginPrompt from './components/ui/LoginPrompt.vue';
import IntegrationsGrid from './components/sections/IntegrationsGrid.vue';
import AppsSection from './components/sections/AppsSection.vue';
import ComingSoonSection from './components/sections/ComingSoonSection.vue';
import MeetingsSection from './components/sections/MeetingsSection.vue';
import WebhooksSettings from './components/settings/WebhooksSettings.vue';
import { computed, nextTick, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useIntegrationStore } from './store/useIntegrationStore';
import { useUserStore } from '@/store/useUserStore';
import { useFeatures } from '@/composables/useFeatures';
import { useTrack, TrackEvents } from '@/composables/useTrack';
import { storeToRefs } from 'pinia';

const integrationStore = useIntegrationStore();
const userStore = useUserStore();
const route = useRoute();
const { getFeature } = useFeatures();
const { track } = useTrack();

const { isLoggedIn, isOrgUserAdmin, isOrgUserViewOnly } = storeToRefs(userStore);
const hasMeetingsFlag = computed(() => getFeature('calendar-meeting-recorder', false).value);

const scrollToHashTarget = async () => {
  if (!route.hash) {
    return;
  }

  await nextTick();

  requestAnimationFrame(() => {
    document.getElementById(route.hash.slice(1))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
};

onMounted(async () => {
  if (isLoggedIn.value) {
    integrationStore.fetchIntegrations();
    // Completes the "Connect your workflows and tools with Zight" prize step.
    track(TrackEvents.VISITED_INTEGRATIONS);
  }

  void scrollToHashTarget();
});

watch([() => route.hash, isLoggedIn, hasMeetingsFlag], () => {
  void scrollToHashTarget();
});
</script>
